import * as z from "zod/v4";

export const getItemsSold = {
  name: "getItemsSold" as const,
  input: z.object({ startDate: z.date(), endDate: z.date() }),
  output: z.object({ itemsSold: z.number() }),
};
